import { Package } from '../models';
import ApiResource from './ApiResource';

class PackageResource extends ApiResource<Package> {
  public endpoint = '/packages';
}

export const packageResource = new PackageResource();
